// reducers/reportReducers.js
import {
  GET_REPORTS_REQUEST,
  GET_REPORTS_SUCCESS,
  GET_REPORTS_FAIL,
  GET_REPORTS_RESET,
  GET_DETAILED_TRANSACTIONS_REQUEST,
  GET_DETAILED_TRANSACTIONS_SUCCESS,
  GET_DETAILED_TRANSACTIONS_FAIL,
  GET_DETAILED_TRANSACTIONS_RESET,
  SET_REPORT_FILTER_REQUEST,
  SET_REPORT_FILTER_SUCCESS,
  SET_REPORT_FILTER_FAIL,
  SET_REPORT_FILTER_RESET,
  EXPORT_REPORTS_REQUEST,
  EXPORT_REPORTS_SUCCESS,
  EXPORT_REPORTS_FAIL,
  EXPORT_REPORTS_RESET,
  GET_AVAILABLE_CLUBS_REQUEST,
  GET_AVAILABLE_CLUBS_SUCCESS,
  GET_AVAILABLE_CLUBS_FAIL,
  GET_AVAILABLE_CLUBS_RESET,
  SET_SELECTED_CLUB,
  CLEAR_SELECTED_CLUB,
  SET_SELECTED_CLUBS,
  CLEAR_SELECTED_CLUBS,
} from '../constants/reportConstants'

export const getReportsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_REPORTS_REQUEST:
      return { loadingGetReports: true }
    case GET_REPORTS_SUCCESS:
      return { loadingGetReports: false, getReportsData: action.payload }
    case GET_REPORTS_FAIL:
      return { loadingGetReports: false, errorGetReports: action.payload }
    case GET_REPORTS_RESET:
      return {}
    default:
      return state
  }
}

export const getDetailedTransactionsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DETAILED_TRANSACTIONS_REQUEST:
      // Keep the current page on screen while the next one loads
      return { ...state, loadingGetDetailedTransactions: true, errorGetDetailedTransactions: undefined }
    case GET_DETAILED_TRANSACTIONS_SUCCESS:
      return {
        loadingGetDetailedTransactions: false,
        getDetailedTransactionsData: action.payload
      }
    case GET_DETAILED_TRANSACTIONS_FAIL:
      return {
        loadingGetDetailedTransactions: false,
        errorGetDetailedTransactions: action.payload
      }
    case GET_DETAILED_TRANSACTIONS_RESET:
      return {}
    default:
      return state
  }
}

export const setReportFilterReducer = (state = { filter: 'today' }, action) => {
  switch (action.type) {
    case SET_REPORT_FILTER_REQUEST:
      return { ...state, loadingSetReportFilter: true }
    case SET_REPORT_FILTER_SUCCESS:
      return {
        loadingSetReportFilter: false,
        setReportFilterData: action.payload,
        filter: action.payload.filter || 'today',
        customStartDate: action.payload.customStartDate || null,
        customEndDate: action.payload.customEndDate || null
      }
    case SET_REPORT_FILTER_FAIL:
      return {
        ...state,
        loadingSetReportFilter: false,
        errorSetReportFilter: action.payload
      }
    case SET_REPORT_FILTER_RESET:
      return { filter: 'today' }
    default:
      return state
  }
}

export const exportReportsReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_REPORTS_REQUEST:
      return { loadingExportReports: true }
    case EXPORT_REPORTS_SUCCESS:
      return {
        loadingExportReports: false,
        exportReportsData: action.payload
      }
    case EXPORT_REPORTS_FAIL:
      return {
        loadingExportReports: false,
        errorExportReports: action.payload
      }
    case EXPORT_REPORTS_RESET:
      return {}
    default:
      return state
  }
}

// Available clubs for reports
export const getAvailableClubsReducer = (state = { clubs: [], isSuperAdmin: false }, action) => {
  switch (action.type) {
    case GET_AVAILABLE_CLUBS_REQUEST:
      return { ...state, loadingAvailableClubs: true }
    case GET_AVAILABLE_CLUBS_SUCCESS:
      return {
        loadingAvailableClubs: false,
        clubs: action.payload.data?.clubs || [],
        isSuperAdmin: action.payload.data?.isSuperAdmin || false,
        totalClubs: action.payload.data?.totalClubs || 0
      }
    case GET_AVAILABLE_CLUBS_FAIL:
      return {
        ...state,
        loadingAvailableClubs: false,
        errorAvailableClubs: action.payload
      }
    case GET_AVAILABLE_CLUBS_RESET:
      return { clubs: [], isSuperAdmin: false }
    default:
      return state
  }
}

// Selected club for reports (Single Club - Legacy)
export const selectedClubReducer = (state = { clubId: null, clubName: null }, action) => {
  switch (action.type) {
    case SET_SELECTED_CLUB:
      return {
        clubId: action.payload.clubId,
        clubName: action.payload.clubName
      }
    case CLEAR_SELECTED_CLUB:
      return { clubId: null, clubName: null }
    default:
      return state
  }
}

// Selected clubs for reports (Multi Club)
export const selectedClubsReducer = (state = { clubIds: [], clubNames: [] }, action) => {
  switch (action.type) {
    case SET_SELECTED_CLUBS:
      return {
        clubIds: action.payload.clubIds,
        clubNames: action.payload.clubNames
      }
    case CLEAR_SELECTED_CLUBS:
      return { clubIds: [], clubNames: [] }
    default:
      return state
  }
}